/**
 * One URL once per apartment. De-dupes by exact string and by Cloudinary public id.
 */
export function uniquePhotoUrls(list: unknown): string[] {
  if (!Array.isArray(list)) return [];
  const seen = new Set<string>();
  const out: string[] = [];

  for (const raw of list) {
    if (typeof raw !== "string") continue;
    const p = raw.trim();
    if (!p) continue;
    if (p.includes("placeholder")) continue;
    // Skip local ChatGPT-named files, but keep Cloudinary/CDN URLs that still
    // contain that original filename in the path.
    if (!/^https?:\/\//i.test(p) && /chatgpt image/i.test(p)) continue;

    const key = photoIdentity(p);
    if (seen.has(key) || seen.has(p)) continue;
    seen.add(key);
    seen.add(p);
    out.push(p);
  }
  return out;
}

/** Stable identity for the same asset under different CDN/transform URLs. */
export function photoIdentity(url: string): string {
  const noQuery = url.split("?")[0] ?? url;
  try {
    const u = new URL(noQuery);
    // …/upload/c_limit,f_auto,…/v1234/folder/name.ext  OR  …/upload/v1234/folder/name
    const m = u.pathname.match(/\/upload\/(?:[^/]+\/)*?(?:v\d+\/)?(.+)$/i);
    if (m?.[1]) {
      return m[1]
        .replace(/\.[a-z0-9]+$/i, "")
        .toLowerCase();
    }
    return u.pathname.toLowerCase();
  } catch {
    return noQuery
      .replace(/\/w_\d+[^/]*\//g, "/")
      .replace(/\.[a-z0-9]+$/i, "")
      .toLowerCase();
  }
}
